var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import CommonService from "../../../api/CommonService";
import { Loading } from 'element-ui';
var AppointmentDeliveryTimeDialog = (function (_super) {
    __extends(AppointmentDeliveryTimeDialog, _super);
    function AppointmentDeliveryTimeDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            phone: '',
            sms_code: '',
        };
        _this.delivery_order_ids = [];
        _this.busieness_name = '';
        _this.order_total = 0;
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now() - 86400000;
            }
        };
        return _this;
    }
    AppointmentDeliveryTimeDialog.prototype.created = function () {
        this.commonService = CommonService.getInstance();
    };
    AppointmentDeliveryTimeDialog.prototype.watchAppointmentDeliveryTime = function (newValue, oldValue) {
        var appointment_delivery_time = new Date(newValue).format('yyyy-MM-dd hh:mm');
        console.log('========', appointment_delivery_time);
        this.saveAppointmentDeliveryTime(appointment_delivery_time, oldValue);
    };
    AppointmentDeliveryTimeDialog.prototype.saveAppointmentDeliveryTime = function (appointment_delivery_time, old_value, check) {
        var _this = this;
        if (check === void 0) { check = 1; }
        var param = {
            delivery_order_ids: this.delivery_order_ids.join(','),
            appointment_delivery_time: appointment_delivery_time,
            check: check,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.commonService.sendAppointmentDeliveryTime(param).then(function (res) {
            loadingInstance.close();
            if (res.data.code != 0) {
                var text = '';
                if (res.data.code == 1) {
                    text = '客户该时间端支持配送！是否预约该时间进行配送？';
                }
                else if (res.data.code == 2) {
                    var time = _this.getTimeHM(appointment_delivery_time);
                    var time_range_text = _this.calculateHalfHourInterval(time);
                    text = "\u5BA2\u6237\u8BE5\u65F6\u95F4\u6BB5\uFF08" + time_range_text + "\uFF09\u4E0D\u652F\u6301\u914D\u9001\u3002\u8BF7\u9009\u62E9\u5176\u4ED6\u65F6\u95F4\u70B9\u8FDB\u884C\u914D\u9001\u3002";
                }
                else if (res.data.code == 3) {
                    text = "\u8BE5\u65F6\u95F4\u6BB5\u5DF2\u88AB\u5176\u4ED6\u4F9B\u5E94\u5546\u9009\u62E9\uFF0C\u8BF7\u91CD\u65B0\u9884\u7EA6\u3002";
                }
                else {
                    _this.$message.error(res.data.msg);
                    return;
                }
                _this.$confirm(text, '提示', {
                    confirmButtonText: '确定',
                }).then(function (confirm_res) {
                    console.log(33333, res);
                    if (res.data.code == 1) {
                        _this.saveAppointmentDeliveryTime(appointment_delivery_time, old_value, 0);
                    }
                    else {
                        _this.formData.appointment_delivery_time = old_value;
                    }
                }).catch(function (err) {
                    console.log(44444, res.data.code);
                    _this.formData.appointment_delivery_time = old_value;
                });
            }
            else {
                _this.$message.success(res.data.msg);
                _this.close();
                console.log('111111,开始刷新页面', _this.opener);
                _this.opener.search();
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    AppointmentDeliveryTimeDialog.prototype.getTimeHM = function (time) {
        var dateTime = new Date(time);
        var h = dateTime.getHours().toString().padStart(2, '0');
        var m = dateTime.getMinutes().toString().padStart(2, '0');
        return h + ":" + m;
    };
    AppointmentDeliveryTimeDialog.prototype.calculateHalfHourInterval = function (time) {
        var inputTime = new Date("1970-01-01T" + time);
        var minutes = inputTime.getMinutes();
        var halfHourStart = new Date(inputTime);
        halfHourStart.setMinutes(minutes < 30 ? 0 : 30);
        var halfHourEnd = new Date(halfHourStart);
        halfHourEnd.setMinutes(halfHourStart.getMinutes() + 30);
        var formattedStartTime = halfHourStart.getHours() + ":" + halfHourStart.getMinutes().toString().padStart(2, '0');
        var formattedEndTime = halfHourEnd.getHours() + ":" + halfHourEnd.getMinutes().toString().padStart(2, '0');
        return formattedStartTime + " \uFF5E " + formattedEndTime;
    };
    AppointmentDeliveryTimeDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AppointmentDeliveryTimeDialog = __decorate([
        Component
    ], AppointmentDeliveryTimeDialog);
    return AppointmentDeliveryTimeDialog;
}(VueDialog));
export default AppointmentDeliveryTimeDialog;
